// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profileDetails_container__PN45w {
  display: flex;
  flex-direction: column;
}

.profileDetails_heading__v28Kq {
  font-family: "Inter";
  font-size: 28px;
  font-weight: 600;
  line-height: 34px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #4d4e4e;
  margin-left: 1%;
  width: fit-content;
}

.profileDetails_backToContainer__kB\\+Nl {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  width: fit-content;
  cursor: pointer;
}
.profileDetails_backToh1__KToe1 {
  font-family: "Inter";
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #5f6d7e;
}

.profileDetails_columns__i\\+N3Z {
  display: flex;
  width: 100%;
}

.profileDetails_span__\\+NtM8 {
  margin: 3px;
  padding: 5px;
  font-family: "Inter";
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #4d4d4d;
}
.profileDetails_spanData__RrXrV {
  margin: 3px;
  padding: 5px;
  font-family: "Inter";
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #7e818c;
}

@media screen and (max-width: 400px) {
  .profileDetails_span__\\+NtM8,
  .profileDetails_spanData__RrXrV {
    font-size: 15px;
    text-align: center;
    width: 200px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/djelatnikProfil/components/profileDetails.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;;IAEE,eAAe;IACf,kBAAkB;IAClB,YAAY;EACd;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n}\n\n.heading {\n  font-family: \"Inter\";\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 34px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #4d4e4e;\n  margin-left: 1%;\n  width: fit-content;\n}\n\n.backToContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 6px;\n  width: fit-content;\n  cursor: pointer;\n}\n.backToh1 {\n  font-family: \"Inter\";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #5f6d7e;\n}\n\n.columns {\n  display: flex;\n  width: 100%;\n}\n\n.span {\n  margin: 3px;\n  padding: 5px;\n  font-family: \"Inter\";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #4d4d4d;\n}\n.spanData {\n  margin: 3px;\n  padding: 5px;\n  font-family: \"Inter\";\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #7e818c;\n}\n\n@media screen and (max-width: 400px) {\n  .span,\n  .spanData {\n    font-size: 15px;\n    text-align: center;\n    width: 200px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `profileDetails_container__PN45w`,
	"heading": `profileDetails_heading__v28Kq`,
	"backToContainer": `profileDetails_backToContainer__kB+Nl`,
	"backToh1": `profileDetails_backToh1__KToe1`,
	"columns": `profileDetails_columns__i+N3Z`,
	"span": `profileDetails_span__+NtM8`,
	"spanData": `profileDetails_spanData__RrXrV`
};
export default ___CSS_LOADER_EXPORT___;
